module.exports = __webpack_public_path__ + "media/images/google_logo_36-7ec375b5.svg";